import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

/**
 * Base Axios instance pointing at the backend.
 * Each hook passes the auth access token via the Authorization header.
 */
export const apiClient = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
})

/** Convenience: build the auth header for a token */
export const authHeader = (token: string) => ({
  headers: { Authorization: `Bearer ${token}` },
})
